import { useEffect, useState } from "react";

export default function useFollowMouse({ maxOffset }: { maxOffset: number }) {
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  useEffect(() => {
    function handleMouseMove(e: MouseEvent) {
      const { innerWidth, innerHeight } = window;
      // Normalize to [-1, 1]
      const x = (e.clientX / innerWidth - 0.5) * 2;
      const y = (e.clientY / innerHeight - 0.5) * 2;
      setOffset({
        x: x * maxOffset,
        y: y * maxOffset,
      });
    }

    function handleOrientation(e: DeviceOrientationEvent) {
      // gamma: left-right [-90,90], beta: front-back [-180,180]
      const x = (e.gamma ?? 0) / 45; // [-2,2] → [-1,1]
      const y = (e.beta ?? 0) / 90; // [-2,2] → [-1,1]
      setOffset({
        x: Math.max(-1, Math.min(1, x)) * maxOffset,
        y: Math.max(-1, Math.min(1, y)) * maxOffset,
      });
    }

    if (window.matchMedia("(pointer: coarse)").matches) {
      // Mobile
      window.addEventListener("deviceorientation", handleOrientation, true);
      return () =>
        window.removeEventListener(
          "deviceorientation",
          handleOrientation,
          true
        );
    } else {
      // Desktop
      window.addEventListener("mousemove", handleMouseMove);
      return () => window.removeEventListener("mousemove", handleMouseMove);
    }
  }, [maxOffset]);

  return offset;
}
